import { createLogger } from "@mocky-balboa/logger";

export const logger = createLogger("@mocky-balboa/server");
